"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelFieldNestedList = exports.FormModelMutatorNestedList = void 0;
const core_api_1 = require("@ikegps/core-api");
const form_field_1 = require("../form.field");
const form_nested_list_builder_1 = require("./form.nested.list.builder");
class FormModelMutatorNestedList extends form_field_1.FormModelMutatorField {
    init(options) {
        if (options == null) {
            return;
        }
        this.state.setFieldValue(this.field.fieldId, Object.assign(Object.assign({}, this.field.stateValue), { options: JSON.parse(JSON.stringify(options)) }));
    }
    get builder() {
        const stateValue = this.field.stateValue;
        if (stateValue != null && stateValue.options != null) {
            return new form_nested_list_builder_1.FormModelFieldNestedListBuilder(JSON.parse(JSON.stringify(stateValue.options)));
        }
        return new form_nested_list_builder_1.FormModelFieldNestedListBuilder();
    }
    clear() {
        this.init({ title: '', values: [] });
    }
}
exports.FormModelMutatorNestedList = FormModelMutatorNestedList;
class FormModelFieldNestedList extends form_field_1.FormModelField {
    static isNestedList(field) {
        return field.type === core_api_1.IkeFieldType.NESTED_LIST;
    }
    get Mutator() {
        if (this._NLMutator == null) {
            this._NLMutator = new FormModelMutatorNestedList(this);
        }
        return this._NLMutator;
    }
    get options() {
        return this.stateValue.options || { title: '', values: [] };
    }
    findOptions(selections) {
        return FormModelFieldNestedList.findNestedListSelections(this.options, selections);
    }
    static findNestedListSelections(options, selections) {
        if (!Array.isArray(selections) || selections.length === 0 || selections[0] == null) {
            return [];
        }
        const searchItem = String(selections[0]);
        if (options == null) {
            return [];
        }
        const option = options.values.find(({ value }) => String(value) === searchItem);
        if (option == null) {
            return [];
        }
        const values = [option];
        if (option.options == null) {
            return values;
        }
        const nextOption = this.findNestedListSelections(option.options, selections.slice(1));
        if (nextOption.length === 0) {
            return [];
        }
        return values.concat(nextOption);
    }
    getField() {
        return this;
    }
}
exports.FormModelFieldNestedList = FormModelFieldNestedList;
//# sourceMappingURL=form.nested.list.js.map